import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { Pager, PaymentTask } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 0960. 支払タスク一覧
 * [GET] /workspaces/:identifier/payment_tasks
 */
type Props = {
  identifier: string;
  page?: number;
  per?: number;
  billing_year_months?: string[];
  payment_task_phase_ids?: number[];
  user_ids?: number[];
  business_partner_ids?: number[];
  team_ids?: number[];
  payment_method_ids?: number[];
  subscribed?: boolean;
  purchase_order_id?: number;
  archived?: boolean;
  enabled?: boolean;
};

export type PaymentTasksResponse = {
  payment_tasks: PaymentTask[];
  pager: Pager;
};
const paymentTasks = (props: Props): Promise<PaymentTasksResponse> => {
  return axios.get(`/api/workspaces/${props.identifier}/payment_tasks`, { params: props });
};

export const usePaymentTasks = (props: Props) => {
  return useQuery({
    queryKey: ['workspaces', props.identifier, 'payment_tasks', { ...props }],
    queryFn: () => paymentTasks(props),
    enabled: props.enabled,
  });
};

export const usePaymentTasksInvalidate = (identifier: string) => {
  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: ['workspaces', identifier, 'payment_tasks'] });
  };

  return { invalidate };
};
